/* UNSCRIPTED 60-second recall test, part 1 of 4: content, state, tracking, helpers, splash and questions.
   Score out of 18 = habit questions (0-6) + spatial test (0-6) + number test (0-6). Computed from the visitor's own answers. */
const FUNNEL = { slug: "recall-test" };
const CONFIG = {
  claimUrl: "https://unscriptedmanual.com/products/unscripted-applied-retrieval-protocol#choose-tier", // live free-manual claim box, same as the other quiz funnels
  webhookUrl: "https://unscripted-coach.fly.dev/api/lead", // stores each lead on the coach server, same endpoint as the other quiz funnels
  ga4Id: "G-5HNFYY4JPS",
  metaPixelId: "1368921325321559"
};

/* ---------- Tracking: same approach as the other quiz funnels (consent-gated GA4 + Meta; reuses the store's fbq) ---------- */
const ATTR_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "ad_id", "angle", "fbclid"];
const ATTR = (() => { const q = new URLSearchParams(location.search), a = {}; ATTR_KEYS.forEach(k => { const v = q.get(k); if (v) a[k] = v.slice(0, 300); }); return a; })();
const TAGS_ON = !/[?&]tags=off\b/.test(location.search) && (!/^(localhost|127\.0\.0\.1|)$/.test(location.hostname) || /[?&]tags=on\b/.test(location.search));
const ON_SHOPIFY = !!(window.Shopify && window.Shopify.shop);
let GA_ON = false, META_ON = false;
function loadGA4() {
  if (!CONFIG.ga4Id || GA_ON) return;
  GA_ON = true;
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { dataLayer.push(arguments); };
  gtag("js", new Date());
  gtag("config", CONFIG.ga4Id, { quiz_funnel: FUNNEL.slug, send_page_view: !ON_SHOPIFY, linker: { domains: ["unscriptedmanual.com"] } });
  const s = document.createElement("script"); s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(CONFIG.ga4Id);
  document.head.appendChild(s);
}
function loadMeta() {
  if (!CONFIG.metaPixelId || META_ON) return;
  META_ON = true;
  if (window.fbq) return;
  !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  fbq("init", CONFIG.metaPixelId);
  if (!ON_SHOPIFY) fbq("track", "PageView");
}
(function loadTags() {
  if (!TAGS_ON) return;
  const apply = c => { if (c.analytics) loadGA4(); if (c.marketing) loadMeta(); };
  if (!(ON_SHOPIFY && window.Shopify.loadFeatures)) return apply({ analytics: true, marketing: true });
  window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], err => {
    const cp = window.Shopify.customerPrivacy;
    if (err || !cp) return apply({ analytics: true, marketing: true });
    const read = () => ({ analytics: cp.analyticsProcessingAllowed(), marketing: cp.marketingAllowed() });
    apply(read());
    document.addEventListener("visitorConsentCollected", () => apply(read()));
  });
})();
const META_EVENTS = { quiz_start: "QuizStart", quiz_gate_view: "QuizGateView", quiz_result_view: "QuizResult", quiz_claim_click: "QuizClaimClick" };
const EVLOG = [];
function track(event, data = {}) {
  const params = { quiz_funnel: FUNNEL.slug, ...data };
  (window.dataLayer = window.dataLayer || []).push({ event, ...params });
  EVLOG.push(event + (Object.keys(data).length ? " " + JSON.stringify(data) : ""));
  try { if (GA_ON && window.gtag) gtag("event", event, params); } catch (e) {}
  try {
    if (!META_ON || !window.fbq) return;
    if (event === "generate_lead") fbq("track", "Lead", { content_name: FUNNEL.slug, content_category: data.quiz_type });
    else if (/^quiz_q\d\d$/.test(event)) fbq("trackCustom", "QuizStep", { quiz_funnel: FUNNEL.slug, step: data.question });
    else if (META_EVENTS[event]) fbq("trackCustom", META_EVENTS[event], params);
  } catch (e) {}
}

/* ---------- Content ---------- */
const Q = {
  q1: { text: "When someone introduces themselves, how quickly does their name slip?",
        opts: [["Within 5 seconds", 0], ["After the conversation ends", 1], ["Rarely", 2]] },
  q2: { text: "If your phone died right now, how many numbers could you dial from memory?",
        opts: [["0 (all in contacts)", 0], ["1 or 2", 1], ["3 or more", 2]] },
  q3: { text: "You need a date, number or address you have seen before. What do you do first?",
        opts: [["Check my phone or notes straight away", 0], ["Try for a few seconds, then check", 1], ["Try to recall it, and check only if I have to", 2]] },
  q4: { text: "What do you most want to hold in your head?",
        opts: [["Names and faces", "names and faces"], ["Numbers and dates", "numbers and dates"], ["Facts for work or study", "facts for work or study"], ["Where I put things", "where you put things"]] }
};
const FLOW = ["q1", "q2", "q3", "spatial", "digits", "q4", "loader", "gate", "result"];
const STEP = { q1: 1, q2: 2, q3: 3, spatial: 4, digits: 5, q4: 6 };
const BACK = { q2: "q1", q3: "q2" };
const SPATIAL_ITEMS = ["KEY", "CUP", "BOOK", "LAMP", "PLANT", "CLOCK"];
const TRICK_ITEMS = ["PEN", "COAT", "MUG"];
const PLACES = ["Fridge", "Sink", "Kettle", "Oven", "Toaster", "Door", "Window", "Table", "Chair", "Bin", "Shelf", "Rug", "Stool", "Counter", "Sofa", "Mirror"];
const CELLS = 16, LOOK = 6, LOOK_TRICK = 8, DIGITS = 6, DIGIT_LOOK = 4;

/* Headline per ad entry point. Ads pass ?angle=e1..e6 (or the words below). Default is E1. */
const HOOKS = {
  e1: { h: 'Phone dead. Whose number do you <span class="mark">still know?</span>', sub: "Answer a few quick questions, take two short memory tests and get your recall score." },
  e2: { h: 'AI remembers it for you. <span class="mark">What is left in your head?</span>', sub: "Find out in about a minute. Get your recall score." },
  e3: { h: 'You saved it. <span class="mark">Do you still know it?</span>', sub: "Test what you can recall without looking. Get your recall score." },
  e4: { h: 'They went from 26 words to 62. <span class="mark">What is your number?</span>', sub: "In one study, adults trained a memory method for 40 days. Find your own starting score in about a minute." },
  e5: { h: 'Lose your phone. <span class="mark">Lose all of this?</span>', sub: "See how much is actually in your head. Get your recall score." },
  e6: { h: 'You remember every room you grew up in. <span class="mark">But not your partner\'s number?</span>', sub: "Rooms are easy to recall. Find out how you do with the rest." }
};
const ANGLE_WORDS = [["e1", "phone_dead"], ["e2", "ai"], ["e3", "saved"], ["e4", "26"], ["e5", "lose"], ["e6", "room"]];
function pickEntry() {
  const a = (ATTR.angle || "").toLowerCase();
  if (HOOKS[a]) return a;
  const hit = ANGLE_WORDS.find(w => a.includes(w[1]));
  return hit ? hit[0] : "e1";
}

/* ---------- State and helpers ---------- */
const st = { id: "splash", ans: {}, sInfo: null, dInfo: null, sScore: 0, dScore: 0, done: false, unlocked: false, email: "", trick: null, entry: pickEntry(), keyHandler: null, resultSeen: false };
const $screen = document.getElementById("screen");
const $back = document.getElementById("back");
const $segs = document.getElementById("segs");
const $stepno = document.getElementById("stepno");
const $top = document.getElementById("top");
const $sticky = document.getElementById("sticky");
const $shell = document.getElementById("shell");
let timer = null, advancing = false, io = null;

const say = t => { document.getElementById("sr").textContent = t; };
const habit = () => ["q1", "q2", "q3"].reduce((s, k) => s + (st.ans[k] == null ? 0 : Q[k].opts[st.ans[k]][1]), 0);
const typeKey = (h, r) => h >= 4 ? (r >= 7 ? "keeper" : "willing") : (r >= 7 ? "navigator" : "outsourcer");
const pickVal = k => st.ans[k] == null ? null : Q[k].opts[st.ans[k]][1];
const NB = " ";
const pad2 = n => (n < 10 ? "0" : "") + n;
function shuffle(a) { a = a.slice(); for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; } return a; }
function later(fn, ms) { timer = setTimeout(fn, ms); }

function chrome(id) {
  const n = STEP[id];
  $back.hidden = !BACK[id];
  $segs.hidden = !n; $stepno.hidden = !n;
  $top.classList.toggle("has-progress", !!n);
  if (n) {
    [...$segs.children].forEach((el, i) => { el.className = i < n - 1 ? "done" : (i === n - 1 ? "now" : ""); });
    $stepno.textContent = "STEP " + n + "/6";
  }
}
function mount(html, focus = "h1, h2") {
  $screen.innerHTML = '<div class="screen">' + html + "</div>";
  window.scrollTo(0, 0);
  const f = $screen.querySelector(focus);
  if (f) { f.setAttribute("tabindex", "-1"); f.focus({ preventScroll: true }); }
}

/* Screen history so the phone's Back button steps back inside the test, and never skips the email step */
function safe(id) {
  if (["spatial", "digits", "loader", "trick", "q4", "gate", "result"].includes(id)) return st.unlocked ? "result" : (st.done ? "gate" : (id === "result" ? "splash" : "q3"));
  return id;
}
function push(id) { try { history.pushState({ id }, "", ""); } catch (e) {} }
window.addEventListener("popstate", e => { if (e.state && e.state.id) go(safe(e.state.id), true); });

function go(id, fromPop) {
  if (timer) { clearTimeout(timer); clearInterval(timer); timer = null; }
  if (io) { io.disconnect(); io = null; }
  st.keyHandler = null;
  $sticky.hidden = true; $shell.classList.remove("has-sticky");
  st.id = id;
  chrome(id);
  if (!fromPop && id !== "splash") push(id);
  ({ splash, q1: question, q2: question, q3: question, q4: question, spatial, digits, loader, gate, result, trick })[id](id);
  if (STEP[id]) say("Step " + STEP[id] + " of 6");
}

/* ---------- Splash and questions ---------- */
function splash() {
  const h = HOOKS[st.entry];
  mount(`
    <section class="splash">
      <p class="eyebrow">Free test &middot; about 60 seconds</p>
      <h1>${h.h}</h1>
      <p class="sub">${h.sub}</p>
      <div class="stack" aria-hidden="true">
        <div class="contact"><i>M</i><b>Mum</b><span class="blank">&bull;&bull;&bull; &bull;&bull;&bull;&bull;</span></div>
        <div class="contact"><i>P</i><b>Partner</b><span class="blank">&bull;&bull;&bull; &bull;&bull;&bull;&bull;</span></div>
        <div class="contact"><i>S</i><b>Child's school</b><span class="blank">&bull;&bull;&bull; &bull;&bull;&bull;&bull;</span></div>
      </div>
      <button class="cta" id="start" type="button">Start the test</button>
      <p class="micro">Free. Your score appears at the end.</p>
    </section>`, "h1");
  document.getElementById("start").addEventListener("click", () => { track("quiz_start", { entry: st.entry }); go("q1"); });
}

function question(id) {
  const q = Q[id];
  mount(`
    <section class="q">
      <h2>${q.text}</h2>
      <div class="opts">
        ${q.opts.map((o, j) => `<button class="opt${st.ans[id] === j ? " sel" : ""}" type="button" data-j="${j}"><span class="k">${"ABCD"[j]}</span><span>${o[0]}</span></button>`).join("")}
      </div>
    </section>`);
  $screen.querySelectorAll(".opt").forEach(b => b.addEventListener("click", () => choose(id, +b.dataset.j)));
}
function choose(id, j) {
  if (advancing) return;
  advancing = true;
  st.ans[id] = j;
  $screen.querySelectorAll(".opt").forEach(b => b.classList.toggle("sel", +b.dataset.j === j));
  track("quiz_q" + pad2(STEP[id]), { question: id });
  const next = FLOW[FLOW.indexOf(id) + 1];
  setTimeout(() => { advancing = false; go(next); }, 220);
}